<template>
  <div class="hero">
    <TheHeader :isDark="((content.theme == 'christmas' || content.theme == 'default') ? true : false)" class="hero__header" />

    <div
      class="hero__hero"
      :class="`--is-${content.theme}`"
    >
      <!-- <div class="hero__snow --is-1"></div>
      <div class="hero__snow --is-2"></div> -->

      <div class="componata-container">
        <FancyHeading class="hero__heading" data-aos="fade-up">
          <template v-slot:title><span v-html="content.title"></span></template>
          <template v-slot:description><span v-html="content.description"></span></template>
        </FancyHeading>

        <p class="u-dp-flex u-m-0-auto u-justify-center" data-aos="fade-up"><Button :href="content.cta.link" size="large" class="u-m-0-auto"><span v-html="content.cta.text"></span></Button></p>

        <div class="hero__pic" data-aos="fade-up">
          <img src="https://cdn.componata.de/wp-content/uploads/2023/04/hero-img.png?width=1200" alt="Componata Präsente">
        </div>

        <!-- <inline-svg
          :src="require('@/assets/images/christmas-page/deco-1.svg')"
          class="hero__deco --is-1"
        />

        <inline-svg
          :src="require('@/assets/images/christmas-page/deco-2.svg')"
          class="hero__deco --is-2"
        />

        <inline-svg
          :src="require('@/assets/images/christmas-page/deco-3.svg')"
          class="hero__deco --is-3"
        />

        <inline-svg
          :src="require('@/assets/images/christmas-page/deco-4.svg')"
          class="hero__deco --is-4"
        /> -->
      </div>
    </div>

    <transition name="hero__nav-transition">
      <div
        v-if="isNavVisible"
        id="sticky-nav"
        class="hero__nav-wrapper"
      >
        <div class="componata-container">
          <div class="hero__nav">
            <ul class="hero__nav-list">
              <li class="hero__nav-item"><a href="#business-features">Übersicht</a></li>
              <li class="hero__nav-item"><a href="#presents-catalog">Fertige Präsente</a></li>
              <li class="hero__nav-item"><a href="#custom-presents">Selbst zusammenstellen</a></li>
              <li class="hero__nav-item"><a href="#contact">Individuelle Anfrage</a></li>
              <li class="hero__nav-item"><a href="#testimonials">Referenzen</a></li>
              <li class="hero__nav-item"><a href="#faq">Häufige Fragen</a></li>
            </ul>

            <Button href="#contact" appearance="primary" class="hero__nav-btn">Kontakt</Button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
// import { UiMixin } from '@/mixins/UiMixin';

import TheHeader from '@/components/TheHeader';
import FancyHeading from '@/components/Pages/FancyHeading';
import Button from '@/components/Common/Button';

export default {
  name: 'Hero',
  // mixins: [UiMixin],
  components: {
    TheHeader,
    FancyHeading,
    Button,
  },
  props: {
    content: {
      type: Object
    }
  },
  data () {
    return {
      isNavVisible: false
    };
  },
  methods: {
    resizeUi () {
      const headerHeight = document.querySelector('#header').offsetHeight;
      this.$el.style.setProperty('--header-gap', `${headerHeight}px`);
    },

    scrolled () {
      if (window.scrollY > 400) {
        this.isNavVisible = true;
      } else {
        this.isNavVisible = false;
      }
    }
  },
  mounted () {
    this.resizeUi();
    this.$store.commit('setUserGroupId', '2571');
    window.addEventListener('resize', this.resizeUi);
    window.addEventListener('scroll', this.scrolled);

    document.querySelector('html').classList.add('u-smooth-scrolling', 'u-smooth-scrolling-padding-top');
  },
  beforeDestroy () {
    document.querySelector('html').classList.remove('u-smooth-scrolling', 'u-smooth-scrolling-padding-top');
  },
  destroyed () {
    window.removeEventListener('resize', this.resizeUi);
    window.removeEventListener('scroll', this.scrolled);
  }
};
</script>

<style lang="scss">
@at-root {
  html.u-smooth-scrolling.u-smooth-scrolling-padding-top {
    scroll-padding-top: 66px;
  }
}
</style>

<style lang="scss" scoped>
/**
 * Hero
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Hero
 * @since 2022-06-28
**/

$component: 'hero';

.#{$component} {
  // Public Vars
  --header-gap: 140px;

  @include font-size(map-get($lp, 'font-size-base'));

  &__header {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;

    ::v-deep .header__notice {
      display: none;
    }
  }

  .componata-container {
    position: relative;
    // outline: 1px solid yellow;
  }

  &__hero {
    position: relative;
    min-height: 600px;
    // overflow-x: hidden;
    padding-top: calc(var(--header-gap) + 3rem);
    background:
      // url('~@/assets/images/bgr-tickling-stars.svg') 30% center no-repeat,
      linear-gradient(180deg, rgba(0, 0, 0, 0) 65.5%, rgba(27, 27, 27, 0.3) 100%),
      radial-gradient(50% 50% at 50% 50%, #C4012E 0%, #5B0117 100%);

    // Themes

    &.--is-default {
      position: relative;
      overflow: hidden;
      padding-top: calc(var(--header-gap) + 4rem);
      background:
        url('~@/assets/images/bgr-tickling-stars.svg') center 30% no-repeat,
        // linear-gradient(180deg, rgba(0, 0, 0, 0) 65.5%, rgba(27, 27, 27, 0.3) 100%),
        // radial-gradient(50% 50% at 50% 50%, #C4012E 0%, #5B0117 100%);
        linear-gradient(180deg, #161616 0%, #1C1C1C 47.4%);

        &:before {
          content: '';
          display: block;
          position: absolute;
          bottom: -30%;
          left: auto;
          right: auto;
          width: 100%;
          height: 100%;
          background: radial-gradient(50% 50% at 50% 50%, #FF2E00 0%, rgba(#FFEA8A, 0) 100%);
          opacity: 0.170;
        }

        .#{$component} {
          &__heading {
            --from: #FFBB8A;
            --to: #FFEA8A;
            --shadow: #000;

            width: 70%;
            margin: 0 auto;
            text-align: center;
            color: $ink;

            ::v-deep .fancy-heading__description {
              width: 60%;
              color: $sky-light;
            }
          }
        }
    }

    &.--is-birthdays {
      padding-top: calc(var(--header-gap) + 4rem);
      background:
        url('~@/assets/images/bgr-confetti-2.svg') center 20% no-repeat,
        linear-gradient(180deg, #FFFDEF 50%, #FFF2C6 100%);

        .#{$component} {
          &__heading {
            --from: #E58D3D;
            --to: #BD9838;
            --shadow: #fff;

            width: 70%;
            margin: 0 auto;
            text-align: center;
            color: $ink;

            ::v-deep .fancy-heading__description {
              width: 60%;
              color: $ink;
            }
          }
        }
    }

    &.--is-easter {
      padding-top: calc(var(--header-gap) + 4rem);
      background:
        url('~@/assets/images/landing-page/bgr-easter.svg') center 40% repeat-x,
        linear-gradient(180deg, #F4FFFF 7.81%, #FFFDEC 46.35%, #FFF1F0 83.33%, #FBF5FF 100%);
      background-size: 100%;

        .#{$component} {
          &__heading {
            --from: #21AFDC;
            --to: #9EB221;
            --shadow: #fff;

            width: 70%;
            margin: 0 auto;
            text-align: center;
            color: $ink;

            ::v-deep .fancy-heading__description {
              width: 60%;
              color: $ink;
            }
          }
        }
    }

    &.--is-christmas {
      background:
        // url('~@/assets/images/bgr-tickling-stars.svg') 30% center no-repeat,
        linear-gradient(180deg, rgba(0, 0, 0, 0) 65.5%, rgba(27, 27, 27, 0.3) 100%),
        radial-gradient(50% 50% at 50% 50%, #C4012E 0%, #5B0117 100%);
    }
  }

  &__snow {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    margin: 0 auto;
    background-position: center calc(var(--header-gap) - 10px);
    background-repeat: repeat-x;
    background-size: 44%;
    pointer-events: none;
    z-index: 0;

    &.--is-1 {
      // display: none;
      background-image: url('~@/assets/images/christmas-page/snow-1.svg');
      opacity: 0.1;
      animation: snow-1 2s ease-in-out infinite alternate;
    }

    &.--is-2 {
      // display: none;
      background-image: url('~@/assets/images/christmas-page/snow-2.svg');
      opacity: 0.3;
      animation: snow-2 2s ease-in-out 2.3s infinite alternate;
    }

    @keyframes snow-1 {
      0% {
        opacity: 0.1;
      }

      100% {
        opacity: 0.06;
      }
    }

    @keyframes snow-2 {
      0% {
        opacity: 0.3;
      }

      100% {
        opacity: 0.1;
      }
    }
  }

  &__deco {
    position: absolute;
    top: 0;
    opacity: 0;
    will-change: transform;

    &.--is-1 {
      top: 3rem;
      left: 0;
      animation: deco 0.7s ease-out 0.6s forwards;
    }

    &.--is-2 {
      left: 6rem;
      animation: deco 0.7s ease-out 1.2s forwards;
    }

    &.--is-3 {
      top: 1rem;
      right: 6rem;
      animation: deco 0.7s ease-out 1.6s forwards;
    }

    &.--is-4 {
      right: 0;
      animation: deco 0.7s ease-out 0.9s forwards;
    }

    @keyframes deco {
      from {
        opacity: 0;
        transform: translateY(-2rem);
      }

      to {
        opacity: 0.4;
        transform: translateY(0);
      }
    }
  }

  &__heading {
    --from: #FFD585;
    --to: #DBA83D;
    --shadow: #000;

    width: 70%;
    margin: 0 auto;
    text-align: center;
    color: $sky-lighter;

    ::v-deep .fancy-heading__description {
      width: 60%;
      color: $sky-lighter;
    }
  }

  &__pic {
    @include margin-top(- map-get($spacers, 6));
    pointer-events: none;
    user-select: none;
    opacity: 0;
    transition-delay: 0.3s;
    transition-duration: 1.6s !important;

    img {
      @include imageRendering;
      margin: 0 auto;
      max-width: 100%;
    }
  }

  &__nav-wrapper {
    // display: none;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    z-index: 14;
    color: $ink;
    background: rgba($white, 1);
    box-shadow: 0px 6px 30px rgba($ink, 0.2);
    transition: all 0.4s ease;
    will-change: transform;
  }

  &__nav-transition {
    &-enter-active, &-leave-active {
      transform: translateY(0);
      opacity: 1;
    }

    &-enter, &-leave-to {
      transform: translateY(-150px);
      // opacity: 0;
    }
  }

  &__nav {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    @include padding(map-get($spacers, 3) 0);
  }

  &__nav-list {
    @include unlist;
    display: flex;
    // flex: 0 1 1;
  }

  &__nav-item {
    @include margin-right(map-get($spacers, 4));
    width: auto;
    color: $ink-light;
    line-break: loose;
    cursor: pointer;

    // &:not(:last-child) {
    //   @include margin-right(map-get($spacers, 4));
    // }

    a {
      color: $ink-light;

      &:active {
        color: $ink;
      }
    }
  }

  &__nav-btn {
    // flex: 1 0 auto
    flex-shrink: 0;
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {
    &__snow {
      background-size: 70%;
    }
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {
    &__heading {
      ::v-deep .fancy-heading__description {
        width: 80%;
      }
    }

    &__nav-wrapper {
      display: none;
    }
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {
    overflow: hidden;

    &__snow {
      background-size: 100%;
    }

    &__deco {
      &.--is-1 {
        display: none;
      }

      &.--is-2 {
        left: 0.5rem;
      }

      &.--is-3 {
        right: 0.5rem;
      }

      &.--is-4 {
        display: none;
      }
    }

    &__heading {
      width: 100%;
    }

    &__pic {
      @include margin-top(- map-get($spacers, 2));

      img {
        max-width: 160%;
        margin: 0 -30%;
      }
    }
  }
}
</style>
